module.exports = __webpack_public_path__ + "media/trail/icons-controls-zoom-out-8a9cb853.svg";